<template>
  <v-container tag="section">
    <validation-observer ref="observer" slim v-slot="{ invalid }">
      <v-row align="center">
        <v-col cols="12">
          <v-container tag="section">
            <parametros-analiticos-ca ref="parametrosAnaliticoCa" />
          </v-container>
        </v-col>

        <v-col cols="12">
          <v-btn
            id="btn-save-analitico-ca"
            color="success"
            min-width="100"
            style="float: right;"
            :disabled="invalid"
            :loading="loading"
            @click="salvar()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>

import AnaliticoCaService from '@/services/AnaliticoCaService.js';
import tourMixins from '@/mixins/tourMixins';

export default {
  name: "AnaliticosCaAdd",

  mixins: [tourMixins],

  components: { 
    ParametrosAnaliticosCa: () => import("@/components/saneamentoVoc/analiticosCa/ParametrosAnaliticosCa.vue"),
  },

  mounted() {
    this.iniciarTourPagina();
  },

  data() {
    return {
      loading: false,
      arrTour: [
        {
          element: '#obras-analitico-ca',
          intro: 'Aqui você poderá inserir códigos das obras que farão parte do analítico.',
          scrollTo: "tooltip",
          position: 'top'
        },
        {
          element: '#tipologias-analitico-ca',
          intro: 'Aqui você poderá inserir tipologias que farão parte do analítico.',
          scrollTo: "tooltip",
          position: 'top'
        },
        {
          element: '#data-imobilizacao-analitico-ca',
          intro: 'Aqui você poderá filtrar, por data de imobilização, as obras que farão parte do analítico.',
          scrollTo: "tooltip",
          position: 'top'
        },
        {
          element: '#flags-analitico-ca',
          intro: 'Aqui você poderá filtrar as obras que farão parte do analítico de acordo com os resultados de cada flag calculadas no Saneamento do VOC.',
          scrollTo: "tooltip",
          position: 'top'
        },
      ]
    }
  },

  methods: {
    salvar() {
      const idCalculo = this.$route.params.id;
      const postData = this.$refs.parametrosAnaliticoCa.exportData();
      
      this.loading = true;
      
      AnaliticoCaService.salvar(idCalculo, postData)
        .then(() => {
          this.$toast.success('Analítico de CA salvo com sucesso.', '', { position:'topRight' })
          this.$router.push({ name: 'Analíticos de CA Histórico' });
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao salvar Analítico de CA.', '', { position:'topRight' });
        })
        .finally(() => this.loading = false);
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  },
};
</script>

<style>

</style>